import { SxProps } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

const DEFAULT_PROPS = {
  activeStepColor: "shades.secondary.400",
  inactiveStepColor: "shades.neutral.100",
  activeStepWidth: "40px",
  inactiveStepWidth: "14px",
};

export interface StepperProps {
  activeStep: number;
  activeStepColor?: string;
  activeStepWidth?: string;
  inactiveStepColor?: string;
  inactiveStepWidth?: string;
  onClickStep: (i: number) => void;
  steps: number;
  sx?: SxProps;
}

const Stepper = ({
  activeStep,
  activeStepWidth = DEFAULT_PROPS.activeStepWidth,
  inactiveStepWidth = DEFAULT_PROPS.inactiveStepWidth,
  activeStepColor = DEFAULT_PROPS.activeStepColor,
  inactiveStepColor = DEFAULT_PROPS.inactiveStepColor,
  onClickStep,
  steps,
  sx,
}: StepperProps) => {
  return (
    <Stack direction="row">
      {[...Array(steps)].map((_, i) => {
        const isActiveStep = activeStep === i;
        return (
          <Box
            onClick={() => onClickStep(i)}
            key={i}
            sx={{
              "&:hover": {
                cursor: "pointer",
              },
              height: "14px",
              borderRadius: "7px",
              m: "4px",
              width: isActiveStep ? activeStepWidth : inactiveStepWidth,
              bgcolor: isActiveStep ? activeStepColor : inactiveStepColor,
              transition: "all 0.2s ease",
              ...sx,
            }}
          />
        );
      })}
    </Stack>
  );
};

export default Stepper;
